import produce from 'immer';
import * as rpaActions from '../actions/rpa';

import {
  SET_QUOTE_CUSTOMER_DATA
} from '../actions/quote';


const initialState = {
  chargeCodesMapped: [],
  chargeCodesUnmapped: [],
  chargesByCustomer: [],
  patientStatistics: {
    customer_id: null,
    total_sum: '',
    year_sum: '',
    avg_sum: '',
    created_at: '',
    updated_at: ''
  },
  chargesByCustomerPagination: {
    currentPage: 1,
    from: 0,
    lastPage: 0,
    perPage: 20,
    to: 0,
    total: 0
  },
  chargeCodesMappedTotalCount: 0,
  chargeCodesUnmappedTotalCount: 0,
  isChargeCodesMappedLoading: false,
  isChargeCodesUnmappedLoading: false,
  isChargesByCustomerLoading: false,
  isChargesPatientStatisticsLoading: false
};

const formReducer = produce((state: IRPAState = initialState, action) => {
  switch (action.type) {
    case rpaActions.GET_RPA_CHARGE_CODES_MAPPED_START: {
      state.isChargeCodesMappedLoading = true;
      break;
    }

    case rpaActions.GET_RPA_CHARGE_CODES_MAPPED_SUCCESS: {
      const { data, total } = action.data.response;

      state.chargeCodesMapped = data;
      state.chargeCodesMappedTotalCount = total;
      state.isChargeCodesMappedLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGE_CODES_MAPPED_FAILED: {
      state.isChargeCodesMappedLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGE_CODES_UNMAPPED_START: {
      state.isChargeCodesUnmappedLoading = true;
      break;
    }

    case rpaActions.GET_RPA_CHARGE_CODES_UNMAPPED_SUCCESS: {
      const { data, total } = action.data.response;

      state.chargeCodesUnmapped = data;
      state.chargeCodesUnmappedTotalCount = total;
      state.isChargeCodesUnmappedLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGE_CODES_UNMAPPED_FAILED: {
      state.isChargeCodesUnmappedLoading = false;
      break;
    }

    case rpaActions.SET_RPA_CHARGE_MAPPED_PRODUCT_START: {
      state.isChargeCodesUnmappedLoading = true;
      break;
    }

    case rpaActions.SET_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS: {
      state.isChargeCodesUnmappedLoading = false;
      break;
    }

    case rpaActions.SET_RPA_CHARGE_MAPPED_PRODUCT_FAILED: {
      state.isChargeCodesUnmappedLoading = false;
      break;
    }

    case rpaActions.UPDATE_RPA_CHARGE_MAPPED_PRODUCT_START: {
      state.isChargeCodesMappedLoading = true;
      break;
    }

    case rpaActions.UPDATE_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS: {
      state.isChargeCodesMappedLoading = false;
      break;
    }

    case rpaActions.UPDATE_RPA_CHARGE_MAPPED_PRODUCT_FAILED: {
      state.isChargeCodesMappedLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_BY_CUSTOMER_START: {
      state.isChargesByCustomerLoading = true;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_BY_CUSTOMER_SUCCESS: {
      const {
        data,
        current_page,
        from,
        last_page,
        per_page,
        to,
        total
      } = action.data.response;

      const sortedChargesByCustomer = data.slice().sort((a, b) => {
        const dateA = new Date(a.bill_date).getTime();
        const dateB = new Date(b.bill_date).getTime();
        return dateB - dateA;
      });

      state.chargesByCustomer = sortedChargesByCustomer;
      state.chargesByCustomerPagination = {
        ...state.chargesByCustomerPagination,
        currentPage: current_page,
        from,
        lastPage: last_page,
        perPage: per_page,
        to,
        total
      };

      state.isChargesByCustomerLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_BY_CUSTOMER_FAILED: {
      state.isChargesByCustomerLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_BY_CUSTOMER_START: {
      state.isChargesPatientStatisticsLoading = true;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_PATIENT_STATISTICS_SUCCESS: {
      const { data } = action.data.response;
      state.patientStatistics = data;
      state.isChargesPatientStatisticsLoading = false;
      break;
    }

    case rpaActions.GET_RPA_CHARGES_BY_CUSTOMER_FAILED: {
      state.isChargesPatientStatisticsLoading = false;
      break;
    }

    case SET_QUOTE_CUSTOMER_DATA: {
      state.chargesByCustomer = initialState.chargesByCustomer;
      state.chargesByCustomerPagination = initialState.chargesByCustomerPagination;
      break;
    }
  }
}, initialState);

export default formReducer;
